export const loginWithFacebook = 'Login with Facebook'
export const loginWithPhone = 'Or with phone number / email'

export const btnNames = {
	loginWithFacebook,
	loginWithPhone
}
